import { Input } from "../../../src/components/ui/input";
import React from "react";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
} from "../../../src/components/ui/card";
import { Label } from "@radix-ui/react-label";
import {
  RadioGroup,
  RadioGroupItem,
} from "../../../src/components/ui/radio-group";
import {
  CreditCard,
  DollarSign,
  ShoppingBag,
} from "lucide-react";

import { WooCommerce } from "../../../src/lib/api";

import CartDetails from "../cart/cartDetails";
import { useCookies } from "react-cookie";
import { useQuery } from "react-query";
import { OrderData } from "../../../src/lib/interfaces";
import { apiCall } from "../../../src/lib/api";
import { useParams } from "react-router-dom";
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../../../src/components/ui/select";
import { countries } from "./locationsData";
import { Checkbox } from "../../../src/components/ui/checkbox";
import Signup from "../signup/signup";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogTitle,
  DialogTrigger,
} from "../../../src/components/ui/dialog";
import { Textarea } from "../../../src/components/ui/textarea";
import { LebaneseCities } from "./citiesInput";
type city = {
  value: string;
  label: string;
};

export default function Checkout() {
  const [cookies] = useCookies([
    "userToken",
    "cartKey",
    "userId",
  ]);
  const [payment, setPayment] = React.useState("cash");
  const [sameAsShipping, setSameAsShipping] =
    React.useState("same");
  const [firstName, setFirstName] = React.useState("");
  const [lastName, setLastName] = React.useState("");
  const [phone, setPhone] = React.useState("");
  const [email, setEmail] = React.useState("");
  const [country, setCountry] = React.useState("LB");
  const [city, setCity] = React.useState("Chtaura");
  const [lebaneseCity, setLebaneseCity] =
    React.useState<city | null>({
      value: "Chtaura",
      label: "Chtaura",
    });
  const [shippingLebaneseCity, setShippingLebaneseCity] =
    React.useState<city | null>({
      value: "",
      label: "",
    });
  const [address, setAddress] = React.useState("");
  const [saveInfo, setSaveInfo] = React.useState(false);
  const { productName, productId, price } = useParams<{
    productName: string;
    productId: string;
    price: string;
  }>();
  const [shippingAddress, setShippingAddress] =
    React.useState("");
  const [shippingCountry, setShippingCountry] =
    React.useState("");
  const [shippingCity, setShippingCity] =
    React.useState("");
  const [shippingFirstName, setShippingFirstName] =
    React.useState("");
  const [shippingLastName, setShippingLastName] =
    React.useState("");
  const [billingPostalCode, setBillingPostalCode] =
    React.useState("1801");
  const [shippingPostalCode, setShippingPostalCode] =
    React.useState("1801");
  const [notes, setNotes] = React.useState("");
  const localKey = localStorage.getItem("cart_key");
  const { data: cartItems } = useQuery(
    ["cartItems"],
    async () => {
      const res = await fetch(
        !cookies.userToken
          ? `${apiCall}/wp-json/cocart/v2/cart/?cart_key=${localKey}`
          : `${apiCall}/wp-json/cocart/v2/cart/`,
        {
          method: "get",
          headers: {
            "Content-type": "application/json",
            Authorization: !cookies.userToken
              ? ""
              : `Bearer ${cookies.userToken}`,
          },
        }
      );
      console.log(localKey);
      if (!res.ok) {
        console.log(`HTTP error: ${res.status}`);
      }
      const response = await res.json();
      return response;
    },
    { enabled: localKey !== null }
  );
  const { data: billing } = useQuery(
    ["users/billing"],
    async () => {
      const res = await WooCommerce.get(
        `customers/${cookies.userId}`
      )
        .then((response: any) => {
          setFirstName(response.data.billing.first_name);
          setLastName(response.data.billing.last_name);
          setEmail(response.data.billing.email);
          setPhone(response.data.billing.phone);
          setCountry(response.data.billing.country);
          setCity(response.data.billing.city);
          setAddress(response.data.billing.address_1);
          return response.data.billing;
        })
        .catch((error: any) => {
          console.log(error.response.data);
        });
      return res;
    },
    { enabled: !!cookies.userToken }
  );
  const lineItems = cartItems?.items?.map((item: any) => {
    return {
      product_id: item.id,
      quantity: String(item.quantity.value),
    };
  });
  const orderDetails: OrderData = {
    customer_id: cookies.userId || 0,
    payment_method: payment,
    payment_method_title: "",
    set_paid: false,
    customer_note: notes,
    billing: {
      first_name: billing?.first_name || firstName,
      last_name: billing?.last_name || lastName,
      address_1: billing?.address_1 || address,
      city:
        country === "LB"
          ? lebaneseCity?.value
          : billing?.city || city,
      country: billing?.country || country,
      email: billing?.email || email,
      phone: billing?.phone || phone,
      postcode: billingPostalCode,
    },
    shipping: {
      first_name: shippingFirstName,
      last_name: shippingLastName,
      address_1: shippingAddress,
      city:
        shippingCountry === "LB"
          ? shippingLebaneseCity?.value || ""
          : shippingCity,
      country: shippingCountry,
      postcode: shippingPostalCode,
    },
    line_items: productId
      ? [{ product_id: productId, quantity: 1 }]
      : lineItems,
    shipping_lines: [
      {
        method_id: "flat_rate",
        method_title: "Flat Rate",
        total: "4.7",
      },
    ],
  };
  React.useEffect(() => {
    if (!cookies.userToken) {
      const infoSaved = localStorage.getItem("infoSaved");
      const fname = localStorage.getItem("firstName");
      const lname = localStorage.getItem("lastName");
      const mobile = localStorage.getItem("phone");
      const city = localStorage.getItem("city");
      const country = localStorage.getItem("country");
      const add = localStorage.getItem("address");
      const email = localStorage.getItem("email");
      if (
        fname &&
        lname &&
        mobile &&
        city &&
        country &&
        add &&
        infoSaved === "true" &&
        email
      ) {
        setAddress(add);
        setCity(city);
        setFirstName(fname);
        setLastName(lname);
        setPhone(mobile);
        setCountry(country);
        setSaveInfo(true);
        setEmail(email);
      }
    }
  }, []);

  // const { data: zones } = useQuery(["zones"], async () => {
  //   const res = await WooCommerce.get(
  //     `shipping_methods/aramex`
  //   )
  //     .then((res: any) => console.log("zoneee", res.data))
  //     .catch((error: any) => console.log(error));
  //   return res;
  // });
  return (
    <div className="sm:mt-36 p-5 mt-16 mb-16 w-full relative">
      <div className="flex gap-2 items-center mb-5">
        {/* <BackButton /> */}
        <h1 className="font-montserrat font-medium text-xl sm:text-2xl">
          Checkout
        </h1>
      </div>

      <div className="flex w-full gap-10 lg:flex-row flex-col font-montserrat">
        <div className="w-full">
          <form>
            <Card className="rounded-none border-0 shadow-none">
              <CardHeader className="border-b p-0">
                <h2 className="text-xl font-medium ">
                  Billing Information
                </h2>
                <CardDescription></CardDescription>
              </CardHeader>
              <CardContent className="mt-5 p-0">
                <div className="w-full gap-10 flex flex-col">
                  <div className="flex flex-col gap-10">
                    <h3 className="font-montserrat font-medium underline underline-offset-4">
                      User Info
                    </h3>
                    <div className="flex sm:flex-row flex-col w-full items-center gap-10">
                      <div className="flex flex-col gap-1 w-full">
                        <Label
                          htmlFor="firstName"
                          className="text-sm"
                        >
                          <span>First Name</span>
                          <span className="text-red-500">
                            *
                          </span>
                        </Label>
                        <Input
                          name="firstName"
                          id="firstName"
                          required
                          className="outline-none rounded-none"
                          placeholder="First Name"
                          value={firstName}
                          onChange={(e) =>
                            setFirstName(e.target.value)
                          }
                        />
                      </div>
                      <div className="flex flex-col gap-1 w-full">
                        <Label
                          htmlFor="lastName"
                          className="text-sm"
                        >
                          <span>Last Name</span>
                          <span className="text-red-500">
                            *
                          </span>
                        </Label>
                        <Input
                          id="lastName"
                          name="lastName"
                          required
                          className="outline-none rounded-none"
                          placeholder="Last Name"
                          value={lastName}
                          onChange={(e) =>
                            setLastName(e.target.value)
                          }
                        />
                      </div>
                    </div>
                    <div className="flex w-full sm:flex-row flex-col items-center gap-10">
                      <div className="flex flex-col gap-1 w-full">
                        <Label
                          htmlFor="email"
                          className="text-sm"
                        >
                          <span>Email</span>
                          <span className="text-red-500">
                            *
                          </span>
                        </Label>
                        <Input
                          name="email"
                          id="email"
                          required
                          type="email"
                          className="outline-none rounded-none"
                          placeholder="Email"
                          value={email}
                          onChange={(e) =>
                            setEmail(e.target.value)
                          }
                        />
                      </div>
                      <div className="flex flex-col gap-1 w-full">
                        <Label
                          htmlFor="phone"
                          className="text-sm"
                        >
                          <span>Phone Number</span>
                          <span className="text-red-500">
                            *
                          </span>
                        </Label>
                        <Input
                          id="phone"
                          name="phone"
                          required
                          className="outline-none rounded-none"
                          placeholder="Phone Number"
                          value={phone}
                          onChange={(e) =>
                            setPhone(e.target.value)
                          }
                        />
                      </div>
                    </div>
                  </div>
                  <div className="flex flex-col gap-10">
                    <h3 className="font-montserrat font-medium underline underline-offset-4">
                      Billing Info
                    </h3>

                    <div className="flex w-full items-center sm:flex-row flex-col gap-10">
                      <div className="flex flex-col gap-1 w-full">
                        <Label
                          htmlFor="country"
                          className="text-sm"
                        >
                          <span>Country</span>
                          <span className="text-red-500">
                            *
                          </span>
                        </Label>
                        <Select
                          onValueChange={(e) =>
                            setCountry(e)
                          }
                          defaultValue={"lb"}
                          value={country}
                        >
                          <SelectTrigger className="w-full rounded-none">
                            <SelectValue placeholder="Select a country" />
                          </SelectTrigger>
                          <SelectContent>
                            <SelectGroup>
                              {countries.map(
                                (country: any) => (
                                  <SelectItem
                                    key={country.name}
                                    value={country.alpha2}
                                    className="flex gap-5"
                                  >
                                    <span>
                                      {country.emoji}
                                    </span>

                                    <span>
                                      {" "}
                                      {country.name}
                                    </span>
                                  </SelectItem>
                                )
                              )}
                            </SelectGroup>
                          </SelectContent>
                        </Select>
                      </div>
                      <div className="flex flex-col gap-1 w-full">
                        <Label
                          htmlFor="City"
                          className="text-sm"
                        >
                          <span>City</span>
                          <span className="text-red-500">
                            *
                          </span>
                        </Label>
                        {country === "LB" ? (
                          <LebaneseCities
                            getCity={(city) =>
                              setLebaneseCity(city || null)
                            }
                          />
                        ) : (
                          <Input
                            name="city"
                            id="city"
                            placeholder="City"
                            value={city}
                            required
                            className="outline-none rounded-none"
                            onChange={(e) =>
                              setCity(e.target.value)
                            }
                          />
                        )}
                      </div>
                      <div className="flex flex-col gap-1 w-full">
                        <Label
                          htmlFor="billingPostalCode"
                          className="text-sm"
                        >
                          <span>Postal Code</span>
                          <span className="text-red-500">
                            *
                          </span>
                        </Label>
                        <Input
                          name="billingPostalCode"
                          id="billingPostalCode"
                          required
                          className="outline-none rounded-none"
                          placeholder="1801"
                          value={billingPostalCode}
                          onChange={(e) =>
                            setBillingPostalCode(
                              e.target.value
                            )
                          }
                        />
                      </div>
                    </div>
                    <div className="flex w-full gap-10 sm:flex-row flex-col">
                      <div className="flex flex-col gap-1 w-full">
                        <Label
                          htmlFor="address"
                          className="text-sm"
                        >
                          <span>Address</span>
                          <span className="text-red-500">
                            *
                          </span>
                        </Label>
                        <Textarea
                          id="address"
                          name="address"
                          placeholder="Address"
                          required
                          className="outline-none rounded-none"
                          value={address}
                          onChange={(e) =>
                            setAddress(e.target.value)
                          }
                        />
                      </div>
                    </div>
                  </div>
                  <div className="flex flex-col gap-10">
                    <div className="flex w-full items-center gap-4 ">
                      <RadioGroup
                        defaultValue="same"
                        className="flex jusitfy-between w-full gap-4 sm:flex-row flex-col"
                        value={sameAsShipping}
                        name="paymentType"
                        onValueChange={(e) =>
                          setSameAsShipping(e)
                        }
                      >
                        <div className="flex items-center space-x-2 w-full">
                          <RadioGroupItem
                            value={"same"}
                            id="same"
                          />
                          <Label
                            htmlFor="same"
                            className="flex text-sm gap-1 items-center"
                          >
                            <span>
                              Ship To Billing Address
                            </span>
                          </Label>
                        </div>
                        <div className="flex items-center space-x-2 w-full">
                          <RadioGroupItem
                            value="diff"
                            id="diff"
                          />
                          <Label
                            htmlFor="areeba"
                            className="flex gap-1 items-center text-sm"
                          >
                            <span>
                              New Shipping Address
                            </span>
                          </Label>
                        </div>
                      </RadioGroup>
                    </div>
                  </div>
                  {sameAsShipping === "diff" && (
                    <div className="flex flex-col gap-10">
                      <h3 className="font-montserrat font-medium underline underline-offset-4">
                        Shipping Info
                      </h3>
                      <div className="flex sm:flex-row flex-col w-full items-center gap-10">
                        <div className="flex flex-col gap-1 w-full">
                          <Label
                            htmlFor="firstName"
                            className="text-sm"
                          >
                            <span>First Name</span>
                            <span className="text-red-500">
                              *
                            </span>
                          </Label>
                          <Input
                            name="firstName"
                            id="firstName"
                            required
                            className="outline-none rounded-none"
                            placeholder="First Name"
                            value={shippingFirstName}
                            onChange={(e) =>
                              setShippingFirstName(
                                e.target.value
                              )
                            }
                          />
                        </div>
                        <div className="flex flex-col gap-1 w-full">
                          <Label
                            htmlFor="lastName"
                            className="text-sm"
                          >
                            <span>Last Name</span>
                            <span className="text-red-500">
                              *
                            </span>
                          </Label>
                          <Input
                            id="lastName"
                            name="lastName"
                            required
                            className="outline-none rounded-none"
                            placeholder="Last Name"
                            value={shippingLastName}
                            onChange={(e) =>
                              setShippingLastName(
                                e.target.value
                              )
                            }
                          />
                        </div>
                      </div>
                      <div className="flex w-full items-center sm:flex-row flex-col gap-4">
                        <div className="flex flex-col gap-1 w-full">
                          <Label
                            htmlFor="country"
                            className="text-sm"
                          >
                            <span>Country</span>
                            <span className="text-red-500">
                              *
                            </span>
                          </Label>
                          <Select
                            onValueChange={(e) =>
                              setShippingCountry(e)
                            }
                            defaultValue={"LB"}
                            value={shippingCountry}
                          >
                            <SelectTrigger className="w-full rounded-none">
                              <SelectValue placeholder="Select a country" />
                            </SelectTrigger>
                            <SelectContent>
                              <SelectGroup>
                                {countries.map(
                                  (country: any) => (
                                    <SelectItem
                                      key={country.name}
                                      value={country.alpha2}
                                      className="flex gap-5"
                                    >
                                      <span>
                                        {country.emoji}
                                      </span>

                                      <span>
                                        {" "}
                                        {country.name}
                                      </span>
                                    </SelectItem>
                                  )
                                )}
                              </SelectGroup>
                            </SelectContent>
                          </Select>
                        </div>
                        <div className="flex flex-col gap-1 w-full">
                          <Label
                            htmlFor="City"
                            className="text-sm"
                          >
                            <span>City</span>
                            <span className="text-red-500">
                              *
                            </span>
                          </Label>
                          {country === "LB" ? (
                            <LebaneseCities
                              getCity={(city) =>
                                setShippingLebaneseCity(
                                  city || null
                                )
                              }
                            />
                          ) : (
                            <Input
                              name="city"
                              id="city"
                              placeholder="City"
                              value={shippingCity}
                              required
                              className="outline-none rounded-none"
                              onChange={(e) =>
                                setShippingCity(
                                  e.target.value
                                )
                              }
                            />
                          )}
                        </div>
                        <div className="flex flex-col gap-1 w-full">
                          <Label
                            htmlFor="shippingPostalCode"
                            className="text-sm"
                          >
                            <span>Postal Code</span>
                            <span className="text-red-500">
                              *
                            </span>
                          </Label>
                          <Input
                            name="shippingPostalCode"
                            id="shippingPostalCode"
                            required
                            className="outline-none rounded-none"
                            placeholder="1801"
                            value={shippingPostalCode}
                            onChange={(e) =>
                              setShippingPostalCode(
                                e.target.value
                              )
                            }
                          />
                        </div>
                      </div>
                      <div className="flex w-full items-center gap-4 sm:flex-row flex-col">
                        <div className="flex flex-col gap-1 w-full">
                          <Label
                            htmlFor="address"
                            className="text-sm"
                          >
                            <span>Address</span>
                            <span className="text-red-500">
                              *
                            </span>
                          </Label>
                          <Textarea
                            id="address"
                            name="address"
                            placeholder="Address"
                            required
                            className="outline-none rounded-none"
                            value={shippingAddress}
                            onChange={(e) =>
                              setShippingAddress(
                                e.target.value
                              )
                            }
                          />
                        </div>
                      </div>
                    </div>
                  )}
                  <div className="flex flex-col gap-10">
                    <h3 className="font-montserrat font-medium underline underline-offset-4">
                      Payment
                    </h3>
                    <div className="flex w-full items-center gap-4 ">
                      <RadioGroup
                        defaultValue="card"
                        className="flex flex-col jusitfy-between w-full gap-4"
                        value={payment}
                        name="paymentType"
                        onValueChange={(e) => setPayment(e)}
                      >
                        <div className="flex items-center space-x-2 w-full">
                          <RadioGroupItem
                            value={"cashPickup"}
                            id="pp"
                            disabled={country !== "LB"}
                          />
                          <Label
                            htmlFor="cashPickup"
                            className="flex text-sm gap-1 items-center"
                          >
                            <ShoppingBag className="w-4 h-4" />
                            <span>Pickup In Store</span>
                          </Label>
                        </div>
                        <div className="flex items-center space-x-2 w-full">
                          <RadioGroupItem
                            value={"cash"}
                            id="pp"
                            disabled={country !== "LB"}
                          />
                          <Label
                            htmlFor="cash"
                            className="flex text-sm gap-1 items-center"
                          >
                            <DollarSign className="w-4 h-4" />
                            <span> Cash On Delivery</span>
                          </Label>
                        </div>
                        <div className="flex flex-col items-start space-x-2 w-full">
                          <div className="flex justify-center items-center gap-2">
                            <RadioGroupItem
                              value="card"
                              id="card"
                            />
                            <Label
                              htmlFor="card"
                              className="flex gap-1 items-center text-sm"
                            >
                              <CreditCard className="w-5 h-5" />

                              <span>Pay By Card</span>
                            </Label>
                          </div>
                          <div className="flex gap-1 items-center mt-2">
                            {" "}
                            <span className="text-[10px]">
                              Powered By
                            </span>{" "}
                            <img
                              src="/montypay.png"
                              alt="montypay"
                              className="w-16"
                            />
                          </div>
                        </div>
                      </RadioGroup>
                    </div>
                  </div>
                </div>
                <div className="mt-10">
                  <Label
                    htmlFor="notes"
                    className="flex gap-1 items-center text-sm"
                  >
                    <span>Notes</span>
                  </Label>
                  <Textarea
                    id="notes"
                    name="notes"
                    placeholder="A GIFT FOR MY BELOVED ONE"
                    required
                    className="outline-none rounded-none"
                    value={notes}
                    onChange={(e) =>
                      setNotes(e.target.value)
                    }
                  />
                </div>
                <div className="flex flex-col justify-between w-full items-start mt-10 gap-5">
                  <div className="flex items-center space-x-2 w-full">
                    <Checkbox
                      id="terms"
                      checked={saveInfo}
                      onCheckedChange={(e: boolean) =>
                        setSaveInfo(e)
                      }
                    />
                    <Label
                      htmlFor="terms"
                      className="flex gap-1 items-center text-sm"
                    >
                      Save My Information For Next Time
                    </Label>
                  </div>
                  <Dialog>
                    <DialogTrigger asChild>
                      <span className="text-sm hover:underline cursor-pointer text-start w-fit">
                        SIGN UP
                      </span>
                    </DialogTrigger>
                    <DialogTitle></DialogTitle>
                    <DialogDescription></DialogDescription>
                    <DialogContent className="sm:max-w-[400px]">
                      <Signup
                        checkout
                        firstName={firstName}
                        lastName={lastName}
                        mail={email}
                      />
                    </DialogContent>
                  </Dialog>
                </div>
              </CardContent>
            </Card>
          </form>
        </div>

        <CartDetails
          checkout
          order={orderDetails}
          cart={cartItems}
          saveInfo={saveInfo}
          item={
            productId
              ? {
                  product_id: productId,
                  name: productName,
                  price: price,
                }
              : null
          }
        />
      </div>
    </div>
  );
}
